import InputValidator from './input_validator'

export default class GridFormValidator {

	static validate(formFields, actionName) {		
		return InputValidator.validate(formFields, actionName)
	}
}
